import { Link } from '@nextui-org/react'
import { forwardRef, type ReactNode } from 'react'
import { Toaster } from 'react-hot-toast'
import { cm } from '~/utils/utils'
import { Footer } from './Footer'
import { CurieLogo } from '../icons'

interface Props {
  children: ReactNode
  className?: string
  isStatic?: boolean
  navigation?: ReactNode
  titleClassName?: string
  /** When true, the logo will not be clickable/navigable */
  disableLogoLink?: boolean
}

export const SiteLayout = forwardRef<HTMLDivElement, Props>(
  (
    { children, className = '', isStatic = false, navigation, titleClassName, disableLogoLink },
    ref
  ) => {
    return (
      <div
        className={cm(
          'site-layout flex items-center w-screen min-h-screen flex-col',
          isStatic ? '' : 'relative',
          className
        )}
        ref={ref}
      >
        <div className='flex w-full max-w-6xl p-4 pt-8 absolute items-center justify-between z-50 bg-light-background'>
          {disableLogoLink ? (
            <div className='flex items-center'>
              <CurieLogo className='w-[80px] text-light-on-background' />
            </div>
          ) : (
            <Link href='/' className='flex items-center'>
              <CurieLogo className='w-[80px] text-light-on-background' />
            </Link>
          )}
          {navigation}
        </div>
        <div
          className={cm(
            'flex-1',
            isStatic ? '' : 'overflow-auto flex flex-col items-center justify-center'
          )}
        >
          {children}
        </div>
        <Footer />
        <Toaster containerStyle={{ zIndex: 99999 }} />
      </div>
    )
  }
)
